var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedalBronze(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21983_223295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.0019C18.6274 24.0019 24 18.6293 24 12.0019C24 5.37453 18.6274 0.00195312 12 0.00195312C5.37257 0.00195312 0 5.37453 0 12.0019C0 18.6293 5.37257 24.0019 12 24.0019Z",
    fill: "url(#paint0_linear_21983_223295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8765 21.591C17.1047 21.591 21.3429 17.3527 21.3429 12.1246C21.3429 6.89645 17.1047 2.6582 11.8765 2.6582C6.6484 2.6582 2.41016 6.89645 2.41016 12.1246C2.41016 17.3527 6.6484 21.591 11.8765 21.591Z",
    fill: "url(#paint1_linear_21983_223295)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.877 20.2519C16.3653 20.2519 20.0039 16.6134 20.0039 12.125C20.0039 7.63661 16.3653 3.99805 11.877 3.99805C7.38856 3.99805 3.75 7.63661 3.75 12.125C3.75 16.6134 7.38856 20.2519 11.877 20.2519Z",
    fill: "url(#paint2_linear_21983_223295)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21983_223295",
    x1: 4.6015,
    y1: 4.60346,
    x2: 17.2572,
    y2: 17.2592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21983_223295",
    x1: 18.0248,
    y1: 18.2729,
    x2: 5.54884,
    y2: 5.79689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21983_223295",
    x1: 5.96889,
    y1: 6.21694,
    x2: 15.6938,
    y2: 15.9419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC56D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5715A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21983_223295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedalBronze);
export default __webpack_public_path__ + "static/media/medal_bronze.e241c69d2fad58329806028f8e04a86b.svg";
export { ForwardRef as ReactComponent };